import { SWRFetcher } from '@commenda/utils';
import { JobType } from '@prisma/client';
import useSWR, { KeyedMutator, SWRConfiguration } from 'swr';
import { JobListResponse } from './types';

export function useJobs({
  corporationId,
  jobType,
  token,
  options,
}: {
  corporationId: number;
  jobType: JobType;
  token?: string;
  options?: SWRConfiguration;
}) {
  const {
    data,
    error,
    mutate,
  }: {
    mutate: KeyedMutator<unknown>;
    error: unknown;
    data: JobListResponse;
  } = useSWR(
    `job/search?jobType=${jobType}&corporationId=${corporationId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    ),
    options
  );

  return {
    data,
    error,
    mutate,
  };
}
